import React, { useEffect, useState, useRef } from 'react'
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Panel } from 'primereact/panel';
import { Dropdown } from 'primereact/dropdown';
import ExpensesReview from "./expenses-review"
import { Util, expenseApi } from '../../services';
import { Menu } from 'primereact/menu';
import properties from '../../config/environmentProperties';
import { toast } from "react-toastify";
import { Dialog } from 'primereact/dialog';
import { Carousel } from 'primereact/carousel';
import { Calendar } from 'primereact/calendar';
import { Timeline } from 'primereact/timeline';
import ApproveExpensePopup from "./expense-approve-popup";
import RejectExpensePopup from "./expense-reject-popup";
import { DescLength } from '../../common/util/constants';
import { MultiSelect } from "primereact/multiselect";

const TeamExpenses = () => {
    const [viewEmpExpenses, setViewEmpExpenses] = useState(false);
    const [clickedViewUser, setClickedViewUser] = useState([]);
    const [viewEmpList, setViewEmpList] = useState([true]);
    const [usersBySuperior, setUsersBySuperior] = useState([]);
    const [selectedUser, setSelectedUser] = useState(null);
    const [expenseEmployeeList, setExpenseEmployeeList] = useState([]);
    const [selectedDraftExpense, setSelectedDraftExpense] = useState([]);
    const [saveDisabled, setSaveDisabled] = useState(true);
    const [currentRowData, setCurrentRowData] = useState(null);
    const [visible, setVisible] = useState(false);
    const docPath = properties.currentEnvironment.docPath + 'expense-documents/';
    const [selectedDateRange, setSelectedDateRange] = useState(null);
    const [startDate, setStartDate] = useState();
    const [endDate, setEndDate] = useState();
    const [timeline, setTimeline] = useState(false);
    const [expenseActivityData, setExpenseActivityData] = useState([]);
    const [currentRow, setCurrentRow] = useState({});
    const [approveDialog, setApproveDialog] = useState(false);
    const [approveRowData, setApproveRowData] = useState({});
    const [selectedApprovedRow, setSelectedApprovedRow] = useState({});
    const [rejectDialog, setRejectDialog] = useState(false);
    const [rejectRowData, setRejectRowData] = useState({});
    const [clickedExpenseCategory, setClickedExpenseCategory] = useState('');
    const [selectedProject, setSelectedProject] = useState({});

    useEffect(() => {
        fetchAllUsersBYSuperior();
        getAllExpenseUsers();
    }, []);

    const getAllExpenseUsers = (param = {}) => {
        expenseApi.getAllUsers(param).then((resp) => {
            try {
                setExpenseEmployeeList(resp.data.data);
            } catch (error) {
                // Error handle
            }
        });
    };

    const getEmpDetails = async (e) => {
        setExpenseEmployeeList([]);
        setSelectedUser(e.value);
        setSelectedDateRange(null)
        setSelectedDraftExpense([])
        setSelectedProject({})
        setSaveDisabled(true);
        let param = {
            userId: e.value.id,
        }
        getAllExpenseUsers(param);
    };

    const fetchAllUsersBYSuperior = () => {
        expenseApi.getAllUsersBySuperiorId().then((resp) => {
            try {
                resp.data.data.map(
                    (user, index) =>
                    (usersBySuperior[index] = {
                        id: user.id,
                        name: user.firstName.charAt(0).toUpperCase() + user.firstName.slice(1) + " " + user.lastName.charAt(0).toUpperCase() + user.lastName.slice(1).trimEnd(),
                        fullName: user.firstName.charAt(0).toUpperCase() + user.firstName.slice(1) + " " + user.lastName.charAt(0).toUpperCase() + user.lastName.slice(1).trimEnd(),
                    })
                );
            } catch (error) {
                // Error handle
            }
        })
    }

    const changeOnCustom = (e) => {
        setSelectedDateRange(e.value)
        setSelectedDraftExpense([])
        setSelectedProject({})
        setSaveDisabled(true);
        var filteredArray = e.value.filter(function (value) {
            return value !== null;
        });
        if (filteredArray?.length == 2) {
            let param = {
                userId: selectedUser ? selectedUser.id : '',
                fromDate: filteredArray[0],
                toDate: filteredArray[1],
            }
            setStartDate(param.fromDate);
            setEndDate(param.toDate);
            expenseApi.getAllUsers(param).then((resp) => {
                try {
                    setExpenseEmployeeList(resp.data.data);
                } catch (error) {
                    // Error handle
                }
            });
            if (e.value[1]) {
                document.getElementsByClassName("p-datepicker")[0].style.display = "none";
            }
        }
    }

    const calendarSection = () => {
        return (
            <div>
                <label htmlFor="range"></label>{" "}
                <Calendar
                    id="range"
                    value={selectedDateRange}
                    onChange={(e) => changeOnCustom(e)}
                    selectionMode="range"
                    readOnlyInput
                    dateFormat="dd/mm/yy"
                    mask="99/99/9999"
                    showIcon
                    placeholder="Select Period"
                />
            </div>
        );
    };

    let events = [];
    expenseActivityData.map((e) => {
        return Util.expenseActivityData(e, events, clickedExpenseCategory)
    })

    const customizedMarker = (item) => {
        return (
            <span className="flex w-2rem h-2rem align-items-center justify-content-center text-white border-circle z-1 shadow-1" style={{ backgroundColor: item.color }}>
                <i className={item.icon}></i>
            </span>
        );
    };

    const customizedContent = (item) => {
        return Util.TimelineView(item, clickedExpenseCategory)
    };

    const viewClaimTimeline = () => {
        setClickedExpenseCategory(currentRow.category);
        getExpenseActivitiesByClaim(currentRow.claimId)
        setTimeline(true);
    }

    const getExpenseActivitiesByClaim = (claimId) => {
        expenseApi.getClaimActivities(claimId).then((resp) => {
            setExpenseActivityData(resp.data.data)
        });
    }

    const myExpenseTimeline = () => {
        return (
            <>
                <Dialog header="Expense Claim TimeLine" maximizable visible={timeline} onHide={() => setTimeline(false)} style={{ overflow: 'hidden' }}>
                    <div className="flex-column" style={{ width: 500, overflow: 'hidden' }}>
                        <Timeline value={events} className="customized-timeline" marker={customizedMarker} content={customizedContent} />
                    </div>
                </Dialog>
            </>
        );
    };

    const statusBodyTemplate = (data) => {
        return (
            <span style={{ borderRadius: "8px", fontSize: "12px", fontWeight: "700" }}>
                {Util.fetchStatus(data.status, data.category)}
            </span>
        );
    };

    const approveExpenseRow = () => {
        // if the projects length is 0 or 1 then open the popup
        if (currentRow.project.length === 1 || currentRow.project.length === 0) {
            setApproveDialog(true);
        } else {
            if (selectedProject[currentRow.claimId]?.length > 0) {
                setApproveDialog(true);
            }
            else {
                toast.error("Select the project from the dropdown menu before proceeding with approval!");
            }
        }
    }

    const approveExpenseRows = () => {
        if (selectedDraftExpense.length > 0) {
            // Check if any selected expense has multiple projects and none of them are selected
            const hasMultipleProjectsUnselected = selectedDraftExpense.some(expense => expense.project.length > 1 && !selectedProject[expense.claimId]?.length);

            if (hasMultipleProjectsUnselected) {
                toast.error("Select the project from the dropdown menu before proceeding with approval!");
                return;
            }
            // Check if all selected expenses have either no projects, a single project, or a project selected from dropdown
            const isValidApprove = selectedDraftExpense.every(expense => {
                return expense.project.length === 0 || expense.project.length === 1 || selectedProject[expense.claimId]?.length > 0;
            });

            if (isValidApprove) {
                setSelectedApprovedRow(selectedProject);
                setApproveDialog(true);
            } else {
                toast.error("Select the project from the dropdown menu before proceeding with approval!");
            }
        } else {
            toast.error("No Records selected for approval!");
        }
    };

    const menu = useRef(null);
    const ReviewActionBodyTemplate = (rowData) => {
        const items = [
            { label: "VIEW TIMELINE", icon: "pi pi-eye", command: viewClaimTimeline },
            (currentRow.status === 1 || currentRow.status === 10) && { label: "APPROVE", icon: "pi pi-check", command: approveExpenseRow },
            (currentRow.status === 1 || currentRow.status === 10) && { label: "REJECT", icon: "pi pi-times", command: (e) => { setRejectDialog(true); setRejectRowData(currentRow) } }
        ].filter(Boolean);

        const showMenu = (event) => {
            setCurrentRow(rowData)
            menu.current.toggle(event);
        };
        return (
            <>
                <Menu style={{ width: "15rem" }}
                    model={items}
                    popup
                    ref={menu}
                />
                <Button
                    className="p-button-rounded p-button-text"
                    icon="pi pi-ellipsis-v"
                    onClick={showMenu}
                />
            </>
        );
    };

    const approveTeamDialog = () => {
        return (
            <Dialog className="pop-up-dialog-recall" header="Approve Team Claim" visible={approveDialog} style={{ width: '380px' }} onHide={() => setApproveDialog(false)}>
                <ApproveExpensePopup
                    updateRejectRow={(data) => approveTeamExpenseData(data)}
                    rejectRow={approveRowData}
                    onClose={(e) => {
                        setApproveDialog(false);
                    }}
                />
            </Dialog>
        );
    };

    const SelectedTeamExpense = (e) => {
        if (e.value.length > 0) {
            setSaveDisabled(false);
        } else {
            setSaveDisabled(true);
        }
        setSelectedDraftExpense(e.value);

        const statusBased = e.value.some(row => row.status !== 1 && row.status !== 10);
        if (statusBased) {
            setSaveDisabled(true)
            toast.warn("cannot update this record.");
        }
        setSelectedDraftExpense(e.value);
    }

    const approveTeamExpenseData = (data) => {
        let param;
        if (selectedDraftExpense.length > 0) {
            const selectedClaimIds = selectedDraftExpense?.map(e => e.claimId);
            var projectListing = [];
            let objProject;
            for (let i = 0; i < selectedDraftExpense.length; i++) {
                if (selectedDraftExpense[i].project) {
                    const expenseProjectIds = selectedDraftExpense[i].project?.map(e => e.projectId);
                    objProject = {
                        claimId: selectedDraftExpense[i].claimId,
                        projectIds: expenseProjectIds
                    };
                    projectListing.push(objProject);
                }
            }
            const result = Object.entries(selectedApprovedRow).map(([claimId, projects]) => {
                const projectIds = projects.map(project => project.projectId);
                return { claimId, projectIds };
            });

            const data2Map = new Map(result.map(item => [item.claimId, item]));
            const claimData = projectListing.map(item => {
                const existingData2 = data2Map.get(item.claimId);
                if (existingData2) {
                    const uniqueProjectIds = [...new Set(existingData2.projectIds)];
                    return { claimId: item.claimId, projectIds: uniqueProjectIds };
                } else {
                    return item;
                }
            });

            param = {
                status: 2,
                claimId: selectedClaimIds,
                reason: data.reason,
                claims: claimData
            };
        } else {
            const claimIds = [currentRow.claimId];
            const projects = currentRow.project.length > 1 ? selectedProject[currentRow?.claimId] : currentRow?.project;
            const expenseProjectIds = projects?.map(e => e.projectId);
            param = {
                status: 2,
                claimId: claimIds,
                reason: data.reason,
                claims: [
                    {
                        claimId: currentRow.claimId,
                        projectIds: expenseProjectIds
                    }
                ]
            };
        }
        try {
            expenseApi.updateDraftExpense(param).then(
                (resp) => {
                    if (resp.data.success === false) {
                        toast.error(resp.data.error);
                        return;
                    }
                    setSaveDisabled(true);
                    toast.success("Expense Record has been Approved & Shared for Further Processing...");
                    setSelectedDraftExpense([])
                    fetchAllUsersBYSuperior();
                    getAllExpenseUsers();
                    setSelectedUser(null)
                    setSelectedDateRange(null)
                },
                (err) => {
                    toast.error("There was some error while updating Expense Data...");
                }
            );
        } catch (error) {
            toast.error("There was some error while updating Expense Data...");
        }
    };

    const RejectExpenseDialog = () => {
        return (
            <Dialog className="pop-up-dialog-recall" header="Reject Expense" visible={rejectDialog} style={{ width: '380px' }} onHide={() => setRejectDialog(false)}>
                <RejectExpensePopup
                    updateRejectRow={(data) => rejectTeamExpenseData(data)}
                    rejectRow={rejectRowData}
                    onClose={(e) => {
                        setRejectDialog(false);
                    }}
                />
            </Dialog>
        );
    };

    const rejectTeamExpenseData = (data) => {
        let claimIds;
        if (selectedDraftExpense.length > 0) {
            claimIds = selectedDraftExpense?.map((item) => item.claimId);
        } else {
            claimIds = [rejectRowData.claimId];
        }
        const param = {
            status: 3,
            claimId: claimIds,
            reason: data.reason,
        };

        try {
            expenseApi.updateDraftExpense(param).then(
                (resp) => {
                    if (resp.data.success === false) {
                        toast.error(resp.data.error);
                        return;
                    }
                    setSaveDisabled(true);
                    toast.success("Expense Record has been Rejected...");
                    setSelectedDraftExpense([])
                    fetchAllUsersBYSuperior();
                    getAllExpenseUsers();
                    setSelectedUser(null)
                    setSelectedDateRange(null)
                },
                (err) => {
                    toast.error("There was some error while updating Expense Data...");
                }
            );
        } catch (error) {
            toast.error("There was some error while updating Expense Data...");
        }
    };

    const docAction = (rowData) => {
        return (
            <>
                <Button icon="pi pi-eye" className="p-button p-button-primary p-button-icon-only ml-2" aria-label="View" tooltip="View Details" tooltipOptions={{ position: "top" }} onClick={() => { setCurrentRowData(rowData); setVisible(true) }} />
            </>
        );
    };

    const renderCarouselContent = (rowData) => {
        return (
            <Carousel
                value={rowData?.docs}
                itemTemplate={yourCarouselItemTemplate}
                numVisible={1}
                numScroll={1}
                circular
            />
        );
    };

    const yourCarouselItemTemplate = (doc) => {
        return (
            <>
                <p>{doc.fileName}</p>
                <iframe src={docPath + doc.fileName} title={`Document ${doc.fileName}`} style={{ width: '100%', height: '900px' }} />
            </>
        )
    };

    const carouselPopup = () => {
        return (
            <Dialog header={'Documents'} visible={visible} style={{ width: '1200px', height: '900px' }} onHide={() => setVisible(false)}>
                {renderCarouselContent(currentRowData)}
            </Dialog>
        )
    }

    const wrapDescription = (rowData) => {
        const description = rowData.description;
        return (
            <div title={description}>
                {description.length > DescLength.DESCRIPTION ? `${description.substring(0, DescLength.DESCRIPTION)}....` : description}
            </div>
        );
    };

    const projectSelection = (rowData) => {
        const MultipleProjects = rowData.project.length > 1;
        const status = rowData.status === 1 || rowData.status === 10;
        const changeUserByProject = (e) => {
            setSelectedProject({ ...selectedProject, [rowData.claimId]: e.target.value })
        }
        if (rowData.project && rowData.project.length > 0) {
            if (MultipleProjects && status) {
                return (
                    <MultiSelect filter value={selectedProject[rowData.claimId]} options={rowData.project} onChange={(e) => { changeUserByProject(e) }} optionLabel="projectName" placeholder="Select Project" maxSelectedLabels={1} showClear={false} style={{ width: "100%" }} />
                );
            }
            else if (MultipleProjects) {
                return Util.userProjects(rowData)
            } else {
                return <span>{rowData?.project[0]?.projectName}</span>;
            }
        }
        else {
            return <span>N/A</span>;
        }
    };

    return (
        <div className="tabview-demo ess-page">
            {viewEmpList && (
                <div>
                    <div className="grid" >
                        <div className="col" >
                            <strong>Select Employee : </strong>
                            <Dropdown style={{ width: "300px" }} placeholder="Select Employees" filter value={selectedUser} options={usersBySuperior} onChange={(e) => { getEmpDetails(e) }} optionLabel="name" className="user-options" />
                        </div>
                        <div className="col" style={{ textAlign: 'right' }}>
                            <div>{calendarSection()}</div>
                        </div>
                    </div>
                    <hr />
                    <div className='ess-table'>
                        <DataTable
                            paginator
                            responsiveLayout="scroll"
                            paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                            currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                            rows={10}
                            rowsPerPageOptions={[10, 20, 50]}
                            Key="id"
                            resizableColumns
                            value={expenseEmployeeList}
                            columnResizeMode="fit"
                            scrollable="horizontal"
                            stripedRows
                            selectionMode="checkbox"
                            selection={selectedDraftExpense}
                            onSelectionChange={(e) => {
                                SelectedTeamExpense(e)
                                const disableSelection = e.value.some(row => row.status !== 1 && row.status !== 10);
                                if (!disableSelection) {
                                    setSelectedDraftExpense(e.value);
                                } else {
                                    setSelectedDraftExpense(e.value);
                                }
                            }}
                        >
                            <Column selectionMode="multiple" headerStyle={{ width: "8rem" }} exportable={false} ></Column>
                            <Column field="claimId" header="Claim ID" style={{ minWidth: '1rem' }} />
                            <Column field="ecn" header="ECN" />
                            <Column field="firstName" header="Name" body={Util.fullNameBody} />
                            <Column field="claimAmount" header="Amount" body={(rowData) => Util.renderClaimAmount(rowData)} />
                            <Column field="category" header="Category" style={{ minWidth: '1rem' }} />
                            <Column field="businessUnits" header="BusinessUnit" style={{ minWidth: '1rem' }} />
                            <Column header="Project" body={projectSelection} />
                            <Column field="description" header="Description" style={{ minWidth: '2rem' }} body={wrapDescription} />
                            <Column field="status" header="Status" style={{ minWidth: '1re' }} body={statusBodyTemplate} />
                            <Column header="Document" style={{ minWidth: '1rem' }} body={docAction} />
                            <Column header="Actions" style={{ minWidth: '1rem' }} body={ReviewActionBodyTemplate} />
                        </DataTable>
                    </div>
                    <div className='mt-2'>
                        <Button label="Approve All" icon="pi pi-check" className='p-button' onClick={approveExpenseRows} disabled={saveDisabled} />
                        <Button label="Reject All" icon="pi pi-times" className='p-button-danger ml-2' onClick={(e) => setRejectDialog(true)} disabled={saveDisabled} />
                    </div>
                </div>
            )}
            {viewEmpExpenses && (
                <ExpensesReview userData={clickedViewUser} />
            )}
            {carouselPopup()}
            {myExpenseTimeline()}
            {approveTeamDialog()}
            {RejectExpenseDialog()}
        </div>
    )
}
export default TeamExpenses;